import { render, staticRenderFns } from "./WorkTypes.vue?vue&type=template&id=3fb7bf66&scoped=true&"
import script from "./WorkTypes.vue?vue&type=script&lang=js&"
export * from "./WorkTypes.vue?vue&type=script&lang=js&"
import style0 from "./WorkTypes.vue?vue&type=style&index=0&id=3fb7bf66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7bf66",
  null
  
)

export default component.exports